import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { StyledEngineProvider } from "@mui/material";
import "./index.css";
import App from "./App.jsx";
import { BrowserRouter } from "react-router-dom";
import KcPage from "./keycloak-theme/login/KcApp.tsx";
import { bootstrapTenantConfig } from "./config/keycloak.js";


const root = ReactDOM.createRoot(document.getElementById("root"));

// 1. Check if we are running in "Keycloak Mode"
if (window.kcContext) {
  // This runs when you type 'npm run start:keycloak' 
  // or when deployed as a JAR on the server.
  root.render(
    <StyledEngineProvider injectFirst>
      {/* Keycloak pages do NOT use BrowserRouter, they are server-rendered pages */}
      <KcPage kcContext={window.kcContext} />
    </StyledEngineProvider>
  );
} else if (import.meta.env.VITE_KC_THEME_DEV === "true" && !window.kcContext) {
    // --- DEVELOPMENT MOCK MODE ---
    // This allows you to preview the Keycloak theme without Docker
    // by injecting a mock context.
    // Uncomment the page you want to preview:
    
    // Window mock injection must happen before rendering
    // We create a temporary root to handle component mounting properly if needed
    // But for now, we just proceed to render KcPage with the mock
    
    const { getKcContextMock } = await import("./keycloak-theme/login/KcContext");
    const mockContext = getKcContextMock({ 
        pageId: "login.ftl"
    });

    root.render(
        <StyledEngineProvider injectFirst>
            <KcPage kcContext={mockContext} />
        </StyledEngineProvider>
    );

} else {
  // --- NORMAL APP MODE ---
  // This runs when you type 'npm start' (your dashboard)

  // Per-business Keycloak (true federation): warm the tenant's Keycloak config
  // from the BFF so login targets the right business realm. No-op unless
  // VITE_FEDERATION_ENABLED === 'true', so current local/dev is unaffected.
  // Returns true only the first time a tenant's realm is resolved; one reload
  // lets the Keycloak instance (built at import) pick up the tenant realm.
  // Loop-safe: the second pass reads the same cached value → returns false.
  // Using .then (not await) to avoid top-level await in the bundle target.
  bootstrapTenantConfig()
    .then((changed) => { if (changed) window.location.reload(); })
    .catch(() => { /* federation off or BFF unreachable — use default config */ });

  root.render(
    // Temporarily disabled StrictMode due to Keycloak double initialization issue
    // <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StyledEngineProvider>
    // </React.StrictMode>
  );
}